import {
	mapState,
	mapActions
} from 'vuex';

export default {
	name: 'activities',
	computed: {
		...mapState({
			classLevel: (state) => state.Class.selected.schoolClassLevel,
			activities: (state) => state.Agenda.agenda.activities,
			ParticipationType: (state) => state.ENUM.ParticipationType,
			participation: (state) => state.Agenda.agenda.participation,
		})
	},
	methods: {
		...mapActions([
			'putAgendaActivities',
			'putAgendaParticipation'
		])
	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/activities/activities/index.js